import Vue from 'vue'
import VueCrontab from 'vue-crontab'
 
Vue.use(VueCrontab);

